
<template>
<!-- 紧急视频设置 -->
  <el-dialog
    :title="$t('lang.emergencySetting')"
    :visible.sync="emergencySettingMess.show"
    width="600px"
    center
  >
    <div class="emergency">
      <!-- 垫片设置 -->
      <div class="item">
        <div class="title"><span>*</span>{{ $t('lang.emergencyFile') }}</div>
        <div class="emergencyFile">
          <public-file-select
              :SelectType="1"
              :AppendBody="false"
              :searchType='0'
              :SelectValue="{
                  fileId: eventDetail.fileId,
                  fileName: eventDetail.tname,
              }"
              :otherParam="{
                placeholder: 'select',
                IFGetJson: false
              }"
              @fileSelectChange="
                  pitchOnFile => fileSeleteChange(pitchOnFile, 1)
                "
          ></public-file-select>
        </div>
      </div>
      <!-- 循环 -->
      <div class="item">
        <el-checkbox v-model="loop" >{{$t('lang.loop')}}</el-checkbox>
      </div>
      <!-- 提示 -->
      <div class="item">
        <span class="tips">{{$t('lang.emergencyTips')}}</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        size="small"
        class="cancelButton"
        @click="cancel"
        >{{ $t("lang.cancel") }}</el-button
      >
      <el-button
        size="small"
        type="primary"
        class="saveButton"
        :loading='emergencySettingLoading'
        @click="save"
        >{{ $t("lang.ConfirmBtn") }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import PublicFileSelect from '@/components/common/PublicFileSelect.vue'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    emergencySettingMess: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      pitchOnFile: {},
      // 选中的文件信息
      eventDetail: {
        fileId: '',
        tname: ''
      },
      // 是否循环
      loop: false,
      emergencySettingLoading: false
    }
  },
  created () {
    this.getEmergency()
  },
  components: {
    PublicFileSelect
  },
  methods: {
    // 文件选择
    fileSeleteChange (pitchOnFile) {
      this.eventDetail = { fileId: pitchOnFile.id, tname: pitchOnFile.name }
    },
    cancel () {
      this.emergencySettingMess.show = false
    },
    // 获取紧急视频信息
    getEmergency () {
      const params = {
        programId: this.$BehaviorSyns.getProgramId()
      }
      this.axios
        .post(Outil.getUrl('/event/emergency/query'), params)
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const result = res.data.result
            this.eventDetail = { fileId: result && result.fileId, tname: result && (result.name || result.nickName) }
            this.loop = result.loop
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch(() => {})
    },
    // 设置紧急视频
    save () {
      if (!this.eventDetail.fileId && this.loop) {
        this.$message.info(this.$t('lang.selectEmergency'))
        return
      }
      const params = {
        emergencyFileId: this.eventDetail.fileId,
        programId: this.$BehaviorSyns.getProgramId(),
        loop: this.loop
      }
      this.emergencySettingLoading = true
      this.axios
        .post(Outil.getUrl('/event/emergency/save'), params)
        .then((res) => {
          this.emergencySettingLoading = false
          if (res.data.errorCode == '0x0') {
            this.$message.success('Success')
            this.emergencySettingMess.show = false
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch((res) => {
          console.log(res)
        })
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep.el-dialog__wrapper{
    .el-dialog{
      .el-dialog__body{
        .emergency{
          .title{
            span{
              color:#E56464;
            }
          }
          .emergencyFile{
            .PublicFileSelect{
              .el-select{
                width: 100%;
                .el-input{
                  .el-input__inner{
                    border: 1px solid #444;
                  }
                }
              }
            }
          }
          .item{
            margin-bottom: 16px;
            .tips{
              color: #666666;
              font-size: 14px
            }
          }
        }
      }
      .el-dialog__footer{
        padding-top: 8px;
        text-align:right;
      }
    }
  }
</style>
